<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-8 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-4 card-header-select-box pr-sm-2">
                    <div class="form-group">
                      <label>{{$t("realEstate.field.province")}}:</label>
                      <v-select label="name"
                              v-model="province"
                              :filterable="false"
                              :options="provinces"
                              @search="onProvinceSearch"
                              @search:focus="onProvinceFocus"
                      >
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
                    <div class="form-group">
                      <label>{{$t("realEstate.field.region")}}:</label>
                      <v-select label="name"
                              v-model="region"
                              :filterable="false"
                              :options="regions"
                              @search="onRegionSearch"
                              @search:focus="onRegionFocus"
                      >
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-sm-4 card-header-select-box pl-sm-2">
                    <div class="form-group">
                      <label>{{$t('realEstate.field.microRegion')}} :</label>
                      <v-select label="name"
                              v-model="microRegion"
                              :options="microRegions"
                              @search="onMicroRegionSearch"
                              @search:focus="onMicroRegionFocus"
                      >
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0"
                        @click="showAnalogSettingsModal(null)"
                        v-if="hasPermission('SETTINGS_BUILDING_ANALOG_LAND_SETTING_ADD')"
                >
                    {{$t("action.add")}}
                </button>
                <button class="all-btn m-0 ml-3" @click="onSearch">
                  <i class="fa fa-search"></i>
                  <span>{{$t('main.search')}}</span>
                </button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Вилоят</th>
                      <th>Туман</th>
                      <th>Мулжал</th>
                      <th>Оралик сумма</th>
                      <th>{{$t("realEstate.field.createdDate")}}</th>
                      <th>{{$t("realEstate.field.createdBy")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.data.province.label}}</td>
                      <td>{{result.data.region.label}}</td>
                      <td>
                          <div v-if="result.data.microRegion">{{result.data.microRegion.label}}</div>
                      </td>
                      <td>
                          <span>{{result.data.minAmount | currency('', 2, { thousandsSeparator: ' ' }) }} - {{result.data.maxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                      </td>
                      <!--<td class="td-actions text-center">-->
                          <!--<button class="all-btn edit-btn table-action" data-original-title="Edit"-->
                                  <!--@click="showAnalogSettingsModal(result)">-->
                              <!--<i class="fa fa-edit"></i>-->
                          <!--</button>-->
                      <!--</td>-->
                      <td>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</td>
                      <td>{{result.createdBy.name}}</td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <AnalogLandSettingsEditModal @change="initList"></AnalogLandSettingsEditModal>
    </div>
</template>

<script>
    import AnalogLandSettingsEditModal from '@/views/config/real-estate/AnalogLandSettingsEditModal.vue'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        name: "AnalogLandSettingsList",
        components: {
            'b-pagination': bPagination,
            AnalogLandSettingsEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterMicroRegion: new AdvancedFilter(),
                results: null,
                province: null,
                region: null,
                microRegion: null,
                provinces: [],
                regions: [],
                microRegions: []
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/real-estate/analog-setting/list/LAND_ANALOG_SETTING', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            showAnalogSettingsModal(data) {
                this.$eventBus.$emit("showAnalogLandSettingsModal", data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onMicroRegionFocus() {
                this.microRegions = [];
                this.filterMicroRegion.region = (this.region && this.region.id) ? this.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onMicroRegionSearch(searchTxt, loading) {
                loading(true);
                this.microRegions = [];
                this.filterMicroRegion.search = searchTxt;
                this.filterMicroRegion.region = (this.region && this.region.id) ? this.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onSearch() {
                this.filter.province = this.province;
                this.filter.region = this.region;
                this.filter.microRegion = this.microRegion;

                this.initList();
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.filterMicroRegion.pageFilter.size = 1000;
            this.initList();
        }
    }
</script>

<style scoped>

</style>